import React, { createContext, useState, useContext } from "react";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const userdata = JSON.parse(localStorage.getItem("user"));
  const [user, setUser] = useState(userdata);

  const login = (userData) => {
    localStorage.setItem("user", JSON.stringify(userData));
    setUser(userData);
  };

  const logout = () => {
    localStorage.removeItem("user");
    setUser(null);
  };

  // Function to check if user has permission for a module and action
  const hasPermission = (module, action) => {
    if (!user || !user.permissions) return false;
    console.log(module, "==module", action, "==action");
    console.log(user.permissions, "==user.permissions");
    const modulePermissions = user.permissions.find(
      (perm) => perm.module === module
    );
    if (!modulePermissions) return false;
    console.log(modulePermissions, "==modulePermissions");

    return modulePermissions.permission
      .map((perm) => perm.permission_type)
      .includes(action);
  };
  console.log(user, "===user");

  return (
    <AuthContext.Provider value={{ user, login, logout, hasPermission }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
